







































































































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '~/utils/nuxt3-migration'
import { AuditPackage } from '~/models/audit/package'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import AuditPackageOptionsList from '~/components/shared/classified/audits/AuditPackageOptionsList.vue'
import { capitalizeSentences } from '~/utils/string'
import AuditPackagePerks from '~/components/shared/classified/audits/AuditPackagePerks.vue'
import { ciAngleDown } from '~/icons/source/solid/angle-down'
import { ciAngleUp } from '~/icons/source/regular/angle-up'
import { AuditOption } from '~/models/audit/option'
import { useAudits } from '~/compositions/audits'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import SpotCheckBadge from '~/components/shared/audits/badges/SpotCheckBadge.vue'

export default defineComponent({
  components: {
    SpotCheckBadge,
    AuditPackageOptionsList,
    CPrice,
    AuditPackagePerks,
    CBadge
  },
  props: {
    package: {
      type: Object as PropType<AuditPackage>,
      required: true
    },
    expand: {
      type: Boolean,
      default: false
    },
    visibleBuyButton: {
      type: Boolean,
      default: true
    },
    visibleDeleteButton: {
      type: Boolean,
      default: false
    },
    visibleEditButton: {
      type: Boolean,
      default: false
    },
    uniqueOptions: {
      type: Array as PropType<AuditOption[]>,
      default: []
    },
    perksPerPackage: {
      type: Array as PropType<
        {
          id: number
          index: number
          perks: string[]
        }[]
      >,
      default: []
    },
    statusBadgeVisible: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const { perksPerPackage, package: auditPackage } = toRefs(props)
    const { getNormalizedPerks } = useAudits()

    const normalizedPerks = computed(() =>
      getNormalizedPerks(perksPerPackage.value, auditPackage.value)
    )

    return {
      capitalizeSentences,
      ciAngleDown,
      ciAngleUp,
      normalizedPerks
    }
  }
})
